import { buildHelpRequestPayload } from '../helpRequest';
import { ColorSelectorMessageView } from './ColorSelector';
import { ColorSelectorSelectorView } from './SelectorView';
import { parseColorSelectorOptions } from './parseOptions';
import { parseColorSelectorReply } from './parseReply';
import type { GenerativeUiDescriptor, GenerativeUiDisplayPayload } from '../types';
import type { ColorSelectorOptions } from './parseOptions';
import type { ColorSelectorReply } from './parseReply';

function parseColorSelectorDisplayPayload(
    data: unknown
): GenerativeUiDisplayPayload<'color-selector', ColorSelectorReply> | null {
    const reply = parseColorSelectorReply(data);

    if (!reply) {
        return null;
    }

    return { type: 'color-selector', data: reply };
}

export const colorSelectorDescriptor: GenerativeUiDescriptor<
    'color-selector',
    ColorSelectorOptions,
    ColorSelectorReply
> = {
    type: 'color-selector',
    parseReply: parseColorSelectorReply,
    parseDisplayPayload: parseColorSelectorDisplayPayload,
    MessageView: ColorSelectorMessageView,
    render: (data) => {
        const payload = parseColorSelectorDisplayPayload(data);

        if (!payload) {
            return null;
        }

        return <ColorSelectorMessageView data={payload.data} />;
    },
    parseOptions: parseColorSelectorOptions,
    renderSelector: (data, onSubmit) => {
        const options = parseColorSelectorOptions(data);

        if (!options) {
            return null;
        }

        return (
            <ColorSelectorSelectorView
                options={options}
                onSubmit={(reply) =>
                    onSubmit(JSON.stringify({ type: 'color-selector', data: reply }))
                }
                onRequestHelp={() =>
                    onSubmit(
                        buildHelpRequestPayload(
                            'color-selector',
                            options.options.map(({ name }) => ({ name }))
                        )
                    )
                }
            />
        );
    },
};
